module.exports = __webpack_public_path__ + "img/Spiff.884173c6.png";